import * as yup from 'yup';
import {
    REVENUE_SHARE_PERCENT_BOUNDS,
    TranslateFn,
    integerIn,
} from '../../../library/validationRules';
import ResourcesIds from '../../../resources/ResourcesIds';
import { TherapistShareFormValues } from '../../../library/models/therapistRevenueShare';

export type { TherapistShareFormValues };

/**
 * What a therapist keeps: a default whole percent between 0 and 100, and optionally a different
 * one for some disciplines.
 *
 * Through `integerIn` against the shared bounds, so the schema and the input's own spinner cannot
 * offer and refuse different things. Zero is deliberately allowed — a therapist on a salary who
 * keeps none of the billing is a real arrangement, and refusing it would leave a clinic writing
 * it as 1%.
 *
 * **Blank is invalid rather than meaning "clear".** Removing a share is its own button in the
 * editor, so a field emptied on the way to retyping can never be read as taking somebody's share
 * away — which is the kind of accident that is only noticed on a payslip.
 */
export const createTherapistShareSchema = (translate: TranslateFn) => yup.object({
    percent: integerIn(REVENUE_SHARE_PERCENT_BOUNDS, translate,
        ResourcesIds.REVENUE_SHARE_PERCENT_INVALID,
        { required: true, requiredKey: ResourcesIds.REVENUE_SHARE_PERCENT_REQUIRED }),
    /**
     * One row per discipline the editor shows. **Blank is valid here**, and means the discipline
     * uses the default — the opposite of the default field, because an override is the
     * exception and most disciplines have none. The bounds are the same ones.
     */
    disciplines: yup.array(yup.object({
        catalogTypeId: yup.number().required(),
        percent: integerIn(REVENUE_SHARE_PERCENT_BOUNDS, translate,
            ResourcesIds.REVENUE_SHARE_PERCENT_INVALID),
    })).required(),
});
